import { render, staticRenderFns } from "./sidebarRemingtonSeeds.vue?vue&type=template&id=54f66204"
import script from "./sidebarRemingtonSeeds.vue?vue&type=script&lang=js"
export * from "./sidebarRemingtonSeeds.vue?vue&type=script&lang=js"
import style0 from "./sidebarRemingtonSeeds.vue?vue&type=style&index=0&id=54f66204&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports